export default [
    {
        path: "adjustment",
        component: () => import('../../views/warehouse/StockAdjustmentView.vue'),
    },
    
    {
        path: "receipt",
        component: () => import("../../views/warehouse/GoodsReceipt.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: "issue",
        component: () => import("../../views/warehouse/GoodsIssue.vue"),
        meta: { requiresAuth: true },
    },     
    {
        path: "issue/:id",
        name: "GoodIssueDisplay",
        component: () => import("../../views/warehouse/GoodIssueDisplayView.vue"),
        meta: { requiresAuth: true },

    },    
]
// metadata